import { css } from 'jimu-core';
function getColLabelStyles(fontSize, paddingY, lineHeight, borderWidth) {
    return `
    padding-top: calc(${paddingY} + ${borderWidth});
    padding-bottom: calc(${paddingY} + ${borderWidth});
    font-size: ${fontSize};
    line-height: ${lineHeight};
  `;
}
export const labelStyles = (props) => {
    var _a, _b, _c;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 'default';
    const isForCheck = props.check;
    const centric = (_b = props.centric) !== null && _b !== void 0 ? _b : false;
    const theme = props.theme;
    const inputVars = (_c = theme === null || theme === void 0 ? void 0 : theme.components) === null || _c === void 0 ? void 0 : _c.input;
    return (inputVars &&
        css `
      &.col-form-label {
        margin-bottom: 0;
        ${getColLabelStyles('inherit', inputVars.sizes.default.paddingY, inputVars.sizes.default.lineHeight, inputVars.border.width)}
      }

      ${size === 'lg' &&
            getColLabelStyles(inputVars.sizes.lg.fontSize, inputVars.sizes.lg.paddingY, inputVars.sizes.lg.lineHeight, inputVars.border.width)}

      ${size === 'sm' &&
            getColLabelStyles(inputVars.sizes.sm.fontSize, inputVars.sizes.sm.paddingY, inputVars.sizes.sm.lineHeight, inputVars.border.width)}

    ${isForCheck &&
            `
      margin-bottom: 0;
    `}
    ${centric &&
            `
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
    `}
    `);
};
